/**
 * Curate Embed — router root.
 *
 * Routes:
 *   /tryOn       → the working try-on flow (TryOn.tsx)
 *   /checkSize   → stub, "Coming soon"
 *   /wardrobe    → stub, "Coming soon"
 *   /            → redirect to /tryOn (the only feature shipped today)
 *   *            → 404 (NotFound.tsx)
 *
 * Each route is its own component / chunk — `React.lazy` splits them so a
 * customer who opens the try-on iframe doesn't download the wardrobe code.
 *
 * Path-based routing requires the static host to do SPA fallback (serve
 * index.html for any unmatched path). Cloudflare Pages, Vercel, Netlify,
 * Firebase Hosting, and Vite's preview server all do this automatically.
 * For plain nginx / S3 + CloudFront, configure the rewrite explicitly.
 */
import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

const TryOn = lazy(() => import('./TryOn'));
const CheckSize = lazy(() => import('./CheckSize'));
const Wardrobe = lazy(() => import('./Wardrobe'));
const NotFound = lazy(() => import('./NotFound'));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Navigate to={{ pathname: '/tryOn', search: window.location.search }} replace />} />
          <Route path="/tryOn" element={<TryOn />} />
          <Route path="/checkSize" element={<CheckSize />} />
          <Route path="/wardrobe" element={<Wardrobe />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

function RouteFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6b6b6b',
        fontFamily: "'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      Loading…
    </div>
  );
}
